import React from "react";
import "./Why_Choose.css";
import Heading_title from "../../common-components/common-title/heading-title/Heading_title";

const Why_Choose = () => {
  return (
    <section className="Why_Choose">
      <div className="container">
        <div className="row">
          <div className="col-md-6 mb-3">
            <div className="left_side">
              <Heading_title title={"Why Choose Nutricos?"} />

              {/* <div className="heading_div">
                <p className="second_heading_text">
                  <span className="green_text">Choose Us </span>for
                </p>
                <p className="second_heading_text">Accuracy & Reliability</p>
              </div> */}

              <p className="simple_text">
                <strong>Made for Everyday Life</strong>
              </p>
              <p className="inner_text">
                From lunchboxes and office breaks to travel munching and evening
                cravings, Nutricos products are crafted to fit seamlessly into
                your daily routine.
              </p>

              <p className="simple_text">
                <strong>Smart Everyday Choice</strong>
              </p>
              <p className="inner_text">
                Tasty, convenient, and affordable products designed for daily
                consumption, helping families enjoy quality snacks and beverages
                without compromising on value.
              </p>

              <p className="simple_text">
                <strong>Easy to Carry. Easy to Enjoy.</strong>                
              </p>
              <p className="inner_text">
                  Choose from handy on-the-go packs for quick snacking or larger
                  family packs perfect for sharing and regular enjoyment.
                </p>

              <p className="simple_text">
                <strong>Available Where You Shop</strong>               
              </p>
               <p className="inner_text">
                  Easily accessible across kirana stores, modern retail outlets,
                  and online platforms throughout Bharat, ensuring your favorite
                  products are always within reach.
                </p>

              <p className="simple_text">
                <strong>Something for Every Mood</strong>
                <br />               
              </p>
               <p className="inner_text">
                  Crunchy snacks, wholesome treats, and refreshing beverages —
                  all brought together under one trusted brand for every
                  occasion.
                </p>
            </div>
          </div>

          <div className="col-md-6">
            <div className="img_div">
              <img
                src="/assets/images/about_us/why_choose/Picture2.png"
                className="machine_img"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Why_Choose;
